import AxiosConfig from '@/config/axios-config'

export const TutorAPI = {

  listar (pagina = null, filtro = []) {
    return AxiosConfig.jalekoAPI().get('/admin/tutores', {
      params: {
        page: pagina,
        nome: filtro.nome,
        email: filtro.email,
        telefone: filtro.telefone
      }
    }).then(response => response.data)
  },

  cadastrar (tutor) {
    return AxiosConfig.secureJalekoAPI().post('/admin/tutores', tutor).then(response => response.data)
  },

  editar (tutor) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/tutores/${tutor.id}`, tutor).then(response => response.data)
  },

  deletar (id) {
    return AxiosConfig.jalekoAPI().delete('/admin/tutores/' + id + '/deletar'
    ).then(response => response.data)
  }

}

export default TutorAPI
